import { ProductPricingDiscriminator } from '@mews/enums';
import { CoProduct } from '@mews/std';

import { MultiCurrencyAmount } from './amounts';

export interface RelativeProductPricing {
    multiplier: number;
    productIds: string[];
    taxRateCodes: string[];
}

type RelativeProductPricingCoProduct = CoProduct<ProductPricingDiscriminator.Relative, RelativeProductPricing>;
type AbsoluteProductPricingCoProduct = CoProduct<ProductPricingDiscriminator.Absolute, MultiCurrencyAmount>;

export type ProductPricingCoProduct = AbsoluteProductPricingCoProduct | RelativeProductPricingCoProduct;

export const isRelativeProductPricingCoProduct = (
    data: ProductPricingCoProduct
): data is RelativeProductPricingCoProduct => data.discriminator === ProductPricingDiscriminator.Relative;
